import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=0c479b87&"
import script from "./MemberCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./MemberCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c479b87')) {
      api.createRecord('0c479b87', component.options)
    } else {
      api.reload('0c479b87', component.options)
    }
    module.hot.accept("./MemberCard.vue?vue&type=template&id=0c479b87&", function () {
      api.rerender('0c479b87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/ethical-commission/index/components/MainContent/components/MemberCard.vue"
export default component.exports